import React, { useEffect, useState } from "react";
import Starting from "./Starting";
import Showcase from "./Showcase";
import Resume from "./Resume";
import Commission from "./Commission";
import ReactCurvedText from "react-curved-text";
import MediaQueryTool from "../../utils/MediaQueryTool";
import { Button, Image, Modal } from "react-bootstrap";
import Delete from "../../assets/delete.svg";

const Home = () => {
  // const unselectableTextStyle = {
  //   userSelect: "none",
  //   WebkitUserSelect: "none",
  //   MozUserSelect: "none",
  //   msUserSelect: "none",
  // };
  const mediaQueryTool = MediaQueryTool();
  const [show, setShow] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showInquired, setShowInquired] = useState(false);
  const [inquiryList, setInquiryList] = useState(
    JSON.parse(localStorage.getItem("inquiryList")) || []
  );

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    if (localStorage.getItem("inquiryList")) {
      setShowInquired(true);
    } else {
      setShowInquired(false);
    }
  }, [inquiryList]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      style={{
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <Starting />
      <Resume />
      <Showcase />
      <Commission setInquiryList={setInquiryList} />

      <div
        style={{
          position: "fixed",
          bottom: mediaQueryTool.isXS ? "30px" : "55px",
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          width: "100%",
          zIndex: 99,
        }}
      >
        {showInquired && (
          <Button
            style={{
              padding: mediaQueryTool.isXS ? "10px 60px" : "10px 200px",
              fontSize: mediaQueryTool.isXS ? 12 : 14,
              borderRadius: "30px",
            }}
            onClick={handleShow}
          >
            Inquired Item
          </Button>
        )}
      </div>

      {showButton && !mediaQueryTool.isXS && (
        <div
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "50px",
            right: "50px",
            width: "110px",
            height: "110px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            color: "white",
            zIndex: 10,
          }}
        >
          <ReactCurvedText
            width={90}
            height={90}
            cx={45}
            cy={45}
            rx={45}
            ry={45}
            startOffset={0}
            reversed={false}
            text="Back to Top Back to Top Back to Top"
            textProps={{
              style: { position: "absolute", fontSize: 17, fill: "white" },
            }}
            textPathProps={null}
            tspanProps={null}
            ellipseProps={null}
            svgProps={{
              className: "circle-animation",
            }}
          />
          <span
            style={{
              position: "absolute",
              zIndex: 2,
              fontSize: 25,
              color: "#fff",
            }}
          >
            ▲
          </span>
        </div>
      )}

      <Modal
        show={show}
        centered={mediaQueryTool.isXS ? true : false}
        onHide={handleClose}
      >
        <Modal.Header
          style={{
            backgroundColor: "#263F5F",
            color: "white",
            borderBottom: "none",
            paddingTop: 8,
          }}
          closeButton
        >
          <Modal.Title style={{ color: "white", alignSelf: "center" }}>
            Inquired List
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "#263F5F",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            color: "white",
            paddingTop: 0,
          }}
        >
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              style={{
                padding: mediaQueryTool.isXS ? "5px 20px" : "3px 20px",
                fontSize: mediaQueryTool.isXS ? 12 : 14,
                borderRadius: "30px",
                backgroundColor: "red",
                border: "red",
                marginTop: mediaQueryTool.isXS ? 15 : undefined,
              }}
              onClick={() => {
                setInquiryList([]);
                localStorage.removeItem("inquiryList");
              }}
            >
              Clear All
            </Button>
          </div>
          <ul
            className="mt-4"
            style={{
              paddingLeft: !mediaQueryTool.isXS ? "50px" : undefined,
              paddingRight: !mediaQueryTool.isXS ? "50px" : undefined,
            }}
          >
            {inquiryList.map((item, index) => {
              return (
                <li
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 15,
                  }}
                  key={index}
                >
                  <label>{item}</label>
                  <Image
                    style={{ cursor: "pointer" }}
                    height={25}
                    width={25}
                    src={Delete}
                    onClick={() => {
                      let inquiryList =
                        JSON.parse(localStorage.getItem("inquiryList")) || [];

                      inquiryList.splice(index, 1);

                      if (inquiryList.length === 0) {
                        localStorage.removeItem("inquiryList");
                      } else {
                        localStorage.setItem(
                          "inquiryList",
                          JSON.stringify(inquiryList)
                        );
                      }

                      setInquiryList(inquiryList);
                    }}
                  />
                </li>
              );
            })}
          </ul>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              style={{
                marginTop: 20,
                padding: mediaQueryTool.isXS ? "8px 40px" : "10px 50px",
                fontSize: mediaQueryTool.isXS ? 12 : 14,
                borderRadius: "30px",
              }}
              href="/contactus"
            >
              Proceed to Inquiry
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
    // <Swiper
    //   direction={"vertical"}
    //   className="mySwiper"
    //   scrollbar={{ draggable: true }}
    //   modules={[Scrollbar, FreeMode]}
    //   style={{ height: "100vh" }}
    // >
    //   <SwiperSlide>
    //     <div
    //       style={{
    //         ...unselectableTextStyle,
    //         height: "100%",
    //         overflowY: "auto",
    //       }}
    //     >
    //       <Starting />
    //     </div>
    //   </SwiperSlide>
    //   <SwiperSlide>
    //     <div
    //       style={{
    //         ...unselectableTextStyle,
    //         height: "100%",
    //         overflowY: "auto",
    //       }}
    //     >
    //       <Showcase />
    //     </div>
    //   </SwiperSlide>
    //   <SwiperSlide>
    //     <div
    //       style={{
    //         ...unselectableTextStyle,
    //         height: "100%",
    //         overflowY: "auto",
    //       }}
    //     >
    //       <Resume />
    //     </div>
    //   </SwiperSlide>
    //   <SwiperSlide>
    //     <div
    //       style={{
    //         ...unselectableTextStyle,
    //         height: "100%",
    //         overflowY: "auto",
    //       }}
    //     >
    //       <Commission />
    //     </div>
    //   </SwiperSlide>
    // </Swiper>
  );
};

export default Home;
